module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAZCAYAAAAbp/98AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABlJREFUeNpiYKAfYGSo0fgPYjDR0VKAAAMAvEEBp0bIa8AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/CUIABA/tituloPagFdo.png
// module id = uYzE
// module chunks = 1